import { msg } from "@lingui/core/macro"
import { useLingui } from "@lingui/react"
import { Trans } from "@lingui/react/macro"
import { Button, Group, Paper, Stack, Text, TextInput } from "@mantine/core"
import type { useCompanyApi } from "../../../../hooks/useCompanyApi"
import { TeamsIntegrationSection } from "../TeamsIntegrationSection"

interface IProps {
  settings: Record<string, string>
  /** Secret keys reported as already-configured (masked) by the backend. */
  configuredSecrets: Set<string>
  saving: boolean
  isAdminOnly: boolean
  /** Owner/admin (or super-admin) may configure Teams; a plain member is read-only. */
  canManage?: boolean
  company: ReturnType<typeof useCompanyApi>
  updateSetting: (key: string, value: string) => void
  save: (keys?: string[]) => void
}

export function IntegrationsPanel({
  settings,
  configuredSecrets,
  saving,
  isAdminOnly,
  canManage = true,
  company,
  updateSetting,
  save,
}: IProps): React.JSX.Element {
  const { i18n } = useLingui()
  return (
    <Stack gap="md">
      {isAdminOnly && (
        <Paper withBorder p="md">
          <Text fw={600} mb="sm">
            <Trans>System defaults</Trans>
          </Text>
          <Stack gap="sm">
            <TextInput
              label={i18n._(msg`Default organization ID`)}
              description={i18n._(msg`Meetings with no company assigned will be shown under this organization.`)}
              placeholder="e.g. 9a5ec176da2e9d8cadd5cb804547ad55"
              value={settings.default_organization_id ?? ""}
              onChange={(e) => updateSetting("default_organization_id", e.currentTarget.value)}
            />
            <Group>
              <Button loading={saving} onClick={() => save(["default_organization_id"])}>
                <Trans>Save</Trans>
              </Button>
            </Group>
          </Stack>
        </Paper>
      )}
      <TeamsIntegrationSection
        settings={settings}
        configuredSecrets={configuredSecrets}
        saving={saving}
        company={company}
        isAdminOnly={isAdminOnly}
        canManage={canManage}
        onUpdateSetting={updateSetting}
        onSave={save}
      />
    </Stack>
  )
}
